module.exports = __webpack_public_path__ + "287256c673bee046f6f3de7139ee519b.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/logo_igi.png
// module id = 870
// module chunks = 0